import React from 'react';
import { useTranslation } from 'react-i18next';
import { isJapanese } from '../../../../../../../utils/lang';
import JP from './JP';
import EN from './EN';

/** サービス概要の本文部分のコンポーネント。 */
const ServiceBody: React.FC = () => {
  const { i18n } = useTranslation();
    return isJapanese(i18n.language) ? <JP/> : <EN/> ;
}

export default ServiceBody;
